export default __webpack_public_path__ + "static/12_31-9efe7ba70a6c71771b39576f101051ba.png";